import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { GlobalContext } from "../../../context/globalContext";
import TkLabelText from "../../../components/atoms/TkLabelText";
import TkButton from "../../../components/atoms/TkButton";
import TkCorporateSearchModal from "../../../components/molecules/TkCorporateSearchModal";
import TkResigneeSearchModal from "../../../components/molecules/TkResigneeSearchModal";
import { httpAPI_CON001, httpAPI_RET019 } from "../api/request";
import "./_style.scss";

type corporateSearchPropsType = {
  onSave: React.Dispatch<any>;
  selectedCorporate: any;
  setSelectedCorporate: React.Dispatch<any>;
  businessType: any;
};

type retireeSearchPropsType = {
  onSave: React.Dispatch<any>;
  businessType: any;
  selectedRetiree: any;
  setSelectedRetiree: React.Dispatch<any>;
};

// 法人検索部品
const CorporateSearch = (props: corporateSearchPropsType) => {
  const { onSave, selectedCorporate, setSelectedCorporate, businessType } =
    props;

  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const [open, setOpen] = useState(false);
  const [corpInfo, setCorpInfo] = useState<any>([]);

  const serchDialogOpen = () => {
    if (!selectedCorporate) {
      setCorpInfo([]);
    }
    setOpen(true);
  };

  const handleCallApi = async (value?: any) => {
    // 契約者一覧参照API 呼び出し
    try {
      const res = await httpAPI_CON001({
        contractorNo: value?.contractorNo,
        corpName: value?.corpName,
        prefectureCd: value?.prefectureCd,
        businessType: businessType,
      });

      if (res.resultCd === "I0000") {
        setState({ ...state, errorMsgId: "" });

        setCorpInfo(res.contractorList);
        setOpen(true);
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleSave = (value: any) => {
    if (!value) return;

    const item = (value.contractorNo ?? "") + ":" + (value.corpName ?? "");
    setSelectedCorporate(item);

    setOpen(false);

    onSave({
      contractorNo: value.contractorNo,
      contractorName: value.corpName,
    });
  };

  return (
    <Box className="SCRW110005">
      <Box className="searchGroup">
        <TkLabelText
          disabled
          wantToSetValue={selectedCorporate}
          variant="standard"
        />
        <TkButton onClick={serchDialogOpen}>法人検索</TkButton>
      </Box>

      <TkCorporateSearchModal
        open={open}
        onClose={() => setOpen(false)}
        onSave={handleSave}
        onChangeSearchData={handleCallApi}
        listData={corpInfo}
      />
    </Box>
  );
};

// 退職者検索部品
const RetireeSearch = (props: retireeSearchPropsType) => {
  const { onSave, businessType, selectedRetiree, setSelectedRetiree } = props;

  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const [open, setOpen] = useState(false);
  const [retireeInfo, setRetireeInfo] = useState<any>([]);

  const handleOpen = () => {
    if (!selectedRetiree) {
      setRetireeInfo([]);
    }
    setOpen(true);
  };

  const handleCallApi = async (value: any) => {
    // 退職者検索API 呼び出し
    try {
      const res = await httpAPI_RET019({
        contractorNo: value.contractorNo,
        contractorName: value.contractorName,
        staffNo: value.staffNo,
        retirementStaffName: value.retirementStaffName,
        retirementStaffBirth: value.retirementStaffBirth,
        businessType: businessType,
      });

      if (res.resultCd === "I0000") {
        setState({ ...state, errorMsgId: "" });

        setRetireeInfo(res.fileList);
        setOpen(true);
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleSave = (value: any) => {
    if (!value) return;
    if (value.staffNo && value.retirementStaffName) {
      const item =
        (value.staffNo ?? "") + ":" + (value.retirementStaffName ?? "");
      value && setSelectedRetiree(item);
    } else {
      const item =
        (value.contractorNo ?? "") + ":" + (value.contractorName ?? "");
      value && setSelectedRetiree(item);
    }

    setOpen(false);

    onSave({
      facilityNo: value.facilityNo,
      contractorNo: value.contractorNo,
      contractorName: value.contractorName,
      staffName: value.retirementStaffName,
      staffNo: value.staffNo,
    });
  };

  return (
    <Box className="SCRW110005">
      <Box className="searchGroup">
        <TkLabelText
          disabled
          wantToSetValue={selectedRetiree}
          variant="standard"
        />
        <TkButton onClick={handleOpen}>退職者検索</TkButton>
      </Box>

      <TkResigneeSearchModal
        open={open}
        onClose={() => setOpen(false)}
        onSave={handleSave}
        onChangeSearchData={handleCallApi}
        listData={retireeInfo}
      />
    </Box>
  );
};

export { CorporateSearch, RetireeSearch };
